import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import NoData from 'components/general/NoData/NoData'

import styles from '../Requisition.module.sass'

const RequisitionHistoryRow = (props) => {
	const { history } = props
	const { modificationDate, modificationUser, text } = history

	return (
		<VStack className={styles['history-row']}>
			<h5>{`${modificationDate?.dateTimeFormat} ${modificationUser}`}</h5>
			<small>{text}</small>
		</VStack>
	)
}

const RequisitionHistory = (props) => {
	const { history } = props
	const { i18n } = useGlobal()

	return history?.length ? (
		(history || []).map((elem, key) => (
			<RequisitionHistoryRow key={key} history={elem} />
		))
	) : (
		<NoData
			applyMaxWidth
			paddings={['normal', 'normal']}
			message={i18n`This process has no extra data to show.`}
		/>
	)
}

export default RequisitionHistory
